module.exports = __webpack_public_path__ + "img/20190822134915QQ截图20190815110903.82ee4dd7.png";